const API_URL = process.env.REACT_APP_API_URL || 'https://blog-9yib.onrender.com';

export default API_URL;